<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <div class="form-group form-row">
        <div class="col-sm-12">
          <button type="button" class="btn btn-block btn-primary" @click="fetchMatches">Load Matches</button>
        </div>
      </div>
      <div class="alert alert-danger" v-if="errorMessage">
        <p><b>Error:</b> {{ errorMessage }}</p>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('matchId')" class="col-sm-4 col-form-label">Match</label>
        <div class="col-sm-8">
          <b-form-select :id="safeId('matchId')" v-model="matchId" :options="optionsMatch"
                         text-field="label" value-field="id">
          </b-form-select>
        </div>
      </div>
      <div v-if="isMatchSelected">
        <div class="form-group form-row">
          <div class="col-sm-12">
            <button type="button" class="btn btn-block btn-secondary" @click="openScoreboard">Scoreboard</button>
          </div>
        </div>
        <div class="form-group form-row">
          <div class="col-sm-12">
            <button type="button" class="btn btn-block btn-secondary" @click="openReferees">Referees</button>
          </div>
        </div>
        <div class="form-group form-row">
          <div class="col-sm-12">
            <button type="button" class="btn btn-block btn-secondary" @click="openHomeTeam">Home Team</button>
          </div>
        </div>
        <div class="form-group form-row">
          <div class="col-sm-12">
            <button type="button" class="btn btn-block btn-secondary" @click="openGuestTeam">Guest Team</button>
          </div>
        </div>
      </div>
    </window-tab>
    <window-tab title="Data" icon="database">
      <div class="form-group form-row">
        <label :for="safeId('federationCode')" class="col-sm-4 col-form-label">Federation code</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('federationCode')" v-model.lazy="federationCode">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('authToken')" class="col-sm-4 col-form-label">Authorization</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('authToken')" v-model.lazy="authToken">
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { uuid } from '@/lib'
  import * as action from '../../store/action-types'
  import { templateMixin } from '@/mixins'
  import mapTemplateOptions from '../../utils/mapTemplateOptions'
  import TemplateDefinitionsService from '../../services/template-definitions.service'
  import VolleyballApi from '../../api/VolleyballApi'

  const AUTH_TOKEN = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6ImEzck1VZ01Gdjl0UGNsTGE2eUYzekFrZnF1RSIsImtpZCI6ImEzck1VZ01Gdjl0UGNsTGE2eUYzekFrZnF1RSJ9.eyJpc3MiOiJodHRwczovL2RhdGFwcm9qZWN0aWRlbnRpdHlzZXJ2ZXIuYXp1cmV3ZWJzaXRlcy5uZXQvY29yZSIsImF1ZCI6Imh0dHBzOi8vZGF0YXByb2plY3RpZGVudGl0eXNlcnZlci5henVyZXdlYnNpdGVzLm5ldC9jb3JlL3Jlc291cmNlcyIsImV4cCI6MTU2NDQ4MTE5OSwibmJmIjoxNTMyOTQ1MTk5LCJjbGllbnRfaWQiOiJ3ZWJhcHAiLCJzY29wZSI6WyJvcGVuaWQiLCJwcm9maWxlIiwiZW1haWwiLCJkcGNsb3Vkc2VydmljZSIsIndjbWFwaXNlcnZpY2UiXSwic3ViIjoiYjYwOTgzYzMtOGNjNy00ZmM0LTkwMTYtZmI3NDk0NTQwNzhkIiwiYXV0aF90aW1lIjoxNTMyOTQ1MTkxLCJpZHAiOiJpZHNydiIsInByZWZlcnJlZF91c2VybmFtZSI6IkNIX1R2c2VydmljZXNAZGF0YXByb2plY3QuY29tIiwiYW1yIjpbInBhc3N3b3JkIl19.Yf-hhKp6EZ1Wnfgg5aBWkKiRWpZYFIBSy5HGenWLKAMNIi0FaxSJaztPU-_w5_ja9YC7R7RKE62iyQnfCZn4ORsycrvcdxvzwlCF59wN2gojO9C2wrA3T1Ms2LHgcOwqmk4UW2fCFy-GqSChXl-yDT4nttqDSU4CP5f8e9EfEMt_O7b7dtzfPHvd43aL00A3G8UwJTTMJWu6kUzw10VqSa7PTr4orJO68eWCPjHtSQCA1U2Vq44d09AxEPDO7c_XAUq788O_NdufpD51nfZdJv1uDdufNbkxy-TS7jnuhgiysX61XjxUd4yhxqtzTzNR3o1Ha0REm1MzCdDTo8fMSw'

  export default {
    name: 'volleyball',
    mixins: [templateMixin],
    data () {
      return {
        errorMessage: null,
        matches: []
      }
    },
    computed: {
      ...mapTemplateOptions({'federationCode': {default: 'SWI'}}),
      ...mapTemplateOptions({'authToken': {default: AUTH_TOKEN}}),
      ...mapTemplateOptions(['matchId']),
      optionsMatch () {
        return this.matches.map(each => {
          const date = new Date(each.MDT)
          return {
            id: each.FedID,
            label: `${each.HName} - ${each.GName} (${date.toLocaleString()})`
          }
        })
      },
      isMatchSelected () {
        return !!(this.matchId && this.getMatch(this.matchId))
      }
    },
    created: function () {
      this.templateDefinitionsService = new TemplateDefinitionsService(this.$keycloak, this.$store)
      this.api = new VolleyballApi(this.$env)
    },
    methods: {
      getApi () {
        return this.api
          .setFederationCode(this.federationCode)
          .setAuthToken(this.authToken)
      },
      fetchMatches () {
        this.errorMessage = null
        this.getApi().getMatchList()
          .then(response => {
            this.matches = response.data
          })
          .catch(error => {
            this.errorMessage = error.message
          })
      },
      getMatch (matchId) {
        if (!this.matches) return null
        return this.matches.find(p => p.FedID === matchId)
      },
      openScoreboard () {
        const match = this.getMatch(this.matchId)
        if (!match) return
        this.openCreate(match, {
          componentType: 'volleyball-scoreboard',
          name: 'Scoreboard',
          overlayData: {
            title1: match.HTTXN || match.HName,
            title2: match.GTTXN || match.GName
          },
          templateOptions: {
            federationCode: this.federationCode,
            authToken: this.authToken,
            matchId: match.FedID
          }
        })
      },
      openReferees () {
        const match = this.getMatch(this.matchId)
        if (!match) return
        this.openCreate(match, {
          componentType: 'generic-lower-third',
          name: 'Referees',
          overlayData: {
            title: [[match.Ref1_N, match.Ref1_SR].join(' '), [match.Ref2_N, match.Ref2_SR].join(' ')].join(' / '),
            subtitle: 'Referees'
          }
        })
      },
      openHomeTeam () {
        this.openTeam('H')
      },
      openGuestTeam () {
        this.openTeam('G')
      },
      openTeam (key) {
        const match = this.getMatch(this.matchId)
        if (!match) return
        this.errorMessage = null
        this.getApi().getRoster(match.FedID)
          .then(response => {
            const teamName = match[key + 'Name']
            const datasetId = uuid()
            const records = response.data['R' + key].map(each => {
              return {
                recordId: uuid(),
                bibNumber: each.N,
                firstName: each.NM,
                lastName: each.SR,
                libero: each.L,
                captain: each.K
              }
            })
            const columns = ['bibNumber', 'firstName', 'lastName', 'libero', 'captain']
            this.$store.dispatch(action.DATASET_CREATE, {
              datasetId,
              name: 'Dataset Roster ' + teamName,
              columns,
              records
            })
            console.log('datasetId', datasetId)
            this.openCreate(match, {
              datasetId,
              name: 'Lower Thirds ' + teamName,
              componentType: 'lower-third-athlete',
              templateData: {
                /* eslint-disable no-template-curly-in-string */
                patternBibNumber: '${bibNumber}',
                patternTitle: '${lastName} ${firstName}',
                patternSubtitle: teamName,
                patternCountry: ''
                /* eslint-enable no-template-curly-in-string */
              },
              overlayData: {
                subtitle: teamName
              }
            })
          })
          .catch(error => {
            this.errorMessage = error.message
          })
      },
      openCreate (match, options) {
        const template = this.templateDefinitionsService.findTemplateDefinition(options.componentType)
        if (!template) {
          console.error('Could not find template definition with componentType "' + options.componentType + '"')
          return
        }
        template.templateId = options.templateId || uuid()
        template.name = options.name
        template.data = Object.assign({}, options.templateData, {
          datasetId: options.datasetId,
          columnMap: options.columnMap
        })
        template.options = Object.assign({}, options.templateOptions)
        template.overlay = {data: Object.assign({}, {title: options.title}, options.overlayData)}
        this.$store.dispatch(action.TEMPLATE_DELETE, {templateId: template.templateId})
        this.$store.dispatch(action.TEMPLATE_CREATE, template)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/volleyball.vue